import { useContext } from 'react';
import { ExperimentationContext } from '../ExperimentationContext';
import { ExperimentationContextValue } from '../types';

/**
 * Hook to access the Experimentation Context.
 * Provides access to the client and its initialization state.
 *
 * @throws {Error} If used outside of ExperimentationProvider
 *
 * @example
 * ```tsx
 * const { client, isReady, isLoading } = useExperimentation();
 * ```
 */
export function useExperimentation(): ExperimentationContextValue {
    const context = useContext(ExperimentationContext);

    if (context === undefined) {
        throw new Error(
            'useExperimentation must be used within an ExperimentationProvider. ' +
                'Wrap your component tree with <ExperimentationProvider> to use this hook.'
        );
    }

    return context;
}
